import React from "react";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Drawer, IconButton } from "@mui/material";
import styles from "./thoughts-drawer.module.css";

type ThoughtsDrawerProps = {
  title: string;
  children: React.ReactNode;
  drawerOpen: boolean;
  onCloseDrawer: () => void;
};

const ThoughtsDrawer = ({
  title,
  drawerOpen,
  onCloseDrawer,
  children,
}: ThoughtsDrawerProps) => {
  return (
    <Drawer
      anchor="right"
      open={drawerOpen}
      onClose={onCloseDrawer}
      variant="persistent"
      classes={{
        root: styles.drawerRoot,
        paper: styles.paperRoot,
      }}
    >
      <div className={styles.drawerHeader}>
        <div className={styles.drawerTitle}>{title}</div>
        <IconButton onClick={onCloseDrawer}>
          <CloseRoundedIcon />
        </IconButton>
      </div>
      <div className={styles.drawerContent}>{children}</div>
    </Drawer>
  );
};

export default ThoughtsDrawer;
